const wx = require("weixin-js-sdk");
import {getWXInfo,ibeaconVerify} from "@/common/api";
import notice from './notice.js'
class ibeacon{
  constructor() {
    this.wxSignatureData={};
    // this.ibeaconStatus="";
  }
  getSignature(){
    let appId = localStorage.getItem("appId"); // 西安服务器APPID
    let data={
      appId,   
      localUrl:location.href,
    };
    getWXInfo(data).then(res => {
      if(res.code=='200'){
        this.wxSignatureData=res.data;
        this.callWeChat();
      }
    })
  }
  callWeChat() {
    let appId = localStorage.getItem("appId"); // 西安服务器APPID
     wx.config({
       debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
       appId, // 必填，公众号的唯一标识
      //  appId: "wxd529d6e2862c8fa8", // 必填，公众号的唯一标识
       timestamp: this.wxSignatureData.timestamp, // 必填，生成签名的时间戳
       nonceStr: this.wxSignatureData.nonceStr, // 必填，生成签名的随机串
       signature: this.wxSignatureData.signature, // 必填，签名
       jsApiList: [
         "openLocation",
         "startSearchBeacons",
         "stopSearchBeacons",
         "getLocation",
         "getNetworkType"
       ] // 必填，需要使用的JS接口列表
     });
  
     wx.error(function(res) {
       // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        // this.ibeaconStatus=false;
        // this.wxSignatureData['ibeaconStatus']=false;
        notice.$emit("getIbeaconStatus",res);
     });
  
     wx.ready(function() {
       // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
       console.log('ready')
       wx.startSearchBeacons({
         ticket: "",
         complete: function() {
           wx.onSearchBeacons({
            complete: function(res) {
              console.log(JSON.stringify(res), "搜索日志");               
              let data={
                beaconsList:JSON.stringify(res.beacons)
              };
              ibeaconVerify(data).then(res => {
                if(res.code=='200'){
                  notice.$emit("getIbeaconStatus",res);
                }
              })

              // for (let b = 0; b < res.beacons.length; b++) {
              //   let str_1 =
              //     res.beacons[b]["major"] +
              //     res.beacons[b]["minor"] +
              //     res.beacons[b]["uuid"];
              //   if (that.list.length == 0) {
              //     res.beacons[b]["ids"] = Math.floor(Math.random() * 100000);
              //     that.list.push(res.beacons[b]);
              //   } else {
              //     let flag = true;
              //     for (let a = 0; a < that.list.length; a++) {
              //       let str_2 =
              //         that.list[a]["major"] +
              //         that.list[a]["minor"] +
              //         that.list[a]["uuid"];
              //       if (str_1 == str_2) {
              //         flag = false;
              //         break;
              //       }
              //     }
              //     if (flag) {
              //       res.beacons[b]["ids"] = Math.floor(
              //         Math.random() * 100000
              //       );
              //       that.list.push(res.beacons[b]);
              //     }
              //   }
              // }

            }
          });
         }
       });
     });
  }
}

let ibeaconMethods=new ibeacon();
export default ibeaconMethods;
   
   